import styled from "styled-components"
import { Button, Modal } from "@prosolve/common-components-ui"

const BodyText = styled.div`
  line-height: 1.5;
  white-space: pre-wrap;
`

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
  padding: 10px;
`

export default ({
  title = 'Confirm',
  message,
  onClose,
  onConfirm,
  children
}) => {
  return (
    <Modal
      title={title}
      onClose={onClose}
      isAutoHeight={true}
      isAutoWidth={true}
      footer={(
        <Footer>
          <Button onClick={onClose}>
            {'Cancel'}
          </Button>
          <Button onClick={onConfirm} $colored={true}>
            {'Confirm'}
          </Button>
        </Footer>
      )}
    >
      {children ?? <BodyText>{message}</BodyText>}
    </Modal>
  )
}
